import { withoutBody } from "@/lib/blog";
import type { GetStaticProps } from "next";
import Layout from "@/components/Layout";
import PageTitle from "@/components/PageTitle";
import BlogCard from "@/components/BlogCard";
import { getPosts } from "@/lib/cms";
import type { BlogPost } from "@/lib/blog";

// Replaces the CodeIgniter default route (Welcome/blog). The CI blog listed
// every published post on one page with no pagination; that behaviour is kept.

type Props = { posts: BlogPost[] };

export default function BlogIndex({ posts }: Props) {
  return (
    <Layout route="/blog">
      <PageTitle title="Our Latest Blogs" crumb="Blogs" />
      <section className="blog-area-two pt-100">
        <div className="container">
          <div className="row">
            {posts.map((post) => (
              <BlogCard key={post.slug} post={post} />
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}

export const getStaticProps: GetStaticProps<Props> = async () => {
  return { props: { posts: (await getPosts()).map(withoutBody) } };
};
